import { FC } from "react";
import { IconButton, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import CloseIcon from "@mui/icons-material/Close";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";

interface BillingExplorerSavingOpportunitiesDrawerHeaderProps {
  onDrawerClose(): void;
}

export const BillingExplorerSavingOpportunitiesDrawerHeader: FC<
  BillingExplorerSavingOpportunitiesDrawerHeaderProps
> = ({ onDrawerClose }) => {
  return (
    <Stack
      top={0}
      direction="row"
      zIndex="appBar"
      position="sticky"
      alignItems="center"
      justifyContent="space-between"
      px={2}
      pt={1}
      pb={0.5}
    >
      <Stack direction="row" spacing={1}>
        <LightbulbOutlinedIcon fontSize="medium" />
        <Typography variant="body1" fontWeight="medium">
          Savings Opportunities
        </Typography>
      </Stack>

      <IconButton onClick={onDrawerClose} size="small">
        <CloseIcon />
      </IconButton>
    </Stack>
  );
};
